import { useState } from "react";
import { Link } from "react-router-dom";
import "../../css/deleteAccount.css";
import { useNavigate } from "react-router-dom";
import {
  FaTrashAlt,
  FaExclamationTriangle,
  FaDatabase,
  FaUserTimes,
  FaPhoneAlt,
  FaLock,
  FaCalendarAlt,
} from "react-icons/fa";
import DeleteAccountFlow from "../../pages/User/DeleteAccountFlow";

import Sidebar from "../../components/comman/Sidebar";
import TopHeader from "../../components/comman/TopHeader";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import { getCurrentUserId } from "../../utils/auth";
import ProfileProvider from "../../context/ProfileContext";

export default function DeleteAccount() {
  const currentUserId = getCurrentUserId();
  const sidebarMenus = getSidebarMenus(currentUserId);
  const [showSidebar, setShowSidebar] = useState(true);
  const [activeSidebar, setActiveSidebar] = useState("delete-account");
  const [feedType, setFeedType] = useState("delete-account");
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [showDeleteFlow, setShowDeleteFlow] = useState(false);
  const navigate = useNavigate();

  const deleteAccountData = [
    {
      profileTitle: "All your data will be permanently removed",
      profileDiscription: "This action cannot be undone",
      profileIcon: FaTrashAlt,
    },
    {
      profileTitle: "Your account cannot be recovered",
      profileDiscription: "Loss of all content and settings",
      profileIcon: FaExclamationTriangle,
    },
    {
      profileTitle: "Associated data will be erased",
      profileDiscription: "Posts, messages, and connections",
      profileIcon: FaDatabase,
    },
    {
      profileTitle: "Username will be removed",
      profileDiscription: "Others can't find you",
      profileIcon: FaUserTimes,
    },
  ];

  const handleDeleteAccount = () => {
    setShowDeleteFlow(true);
  };

  return (
    <ProfileProvider>
      <div className="container-xxl p-0">
        <div className="feed-page-wrapper">
          <TopHeader
            onToggleSidebar={() => setShowSidebar((prev) => !prev)}
            onOpenMessages={() => setShowMsgDrawer(true)}
            creditAmount={50}
            notificationCount={5}
            messageCount={0}
          />

          <div className="prime-layout-container .container-fluid">
            <div className="row">
              {!showSidebar && (
                <div
                  className="left-sidebar-overlay d-md-none"
                  onClick={() => setShowSidebar(true)}
                />
              )}

              <Sidebar
                showSidebar={showSidebar}
                sidebarMenus={sidebarMenus}
                activeSidebar={activeSidebar}
                feedType={feedType}
                onNavigate={(item) => {
                  setActiveSidebar(item.key);
                  if (item.path) {
                    navigate(item.path);
                  }
                }}
              />

              <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
                <div className="center-area">
                  <div className="w-100">
                    <div className="deleteAccount_container">
                      <div className="deleteAccount_container_section">
                        <div className="deleteAccount_section_title">
                          <h2>Delete your account</h2>
                          <div className="notice-banner">
                            <FaExclamationTriangle />
                            <p>
                              To delete your account and all associated data,
                              please verify your identity. Your request will be
                              processed with a{" "}
                              <strong>30-day grace period</strong>
                            </p>
                          </div>
                        </div>

                        <div className="deleteAccount_section">
                          {deleteAccountData.map((item, idx) => {
                            return (
                              <div className="deleteAccount_card" key={idx}>
                                <div className="deleteAccount_icon">
                                  <item.profileIcon />
                                </div>
                                <div className="deleteAccount_policy">
                                  <h3>{item.profileTitle}</h3>
                                  <p>{item.profileDiscription}</p>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        <div className="deleteAccount_bottom_section">
                          <div className="deleteAccount_button">
                            <button
                              onClick={() => handleDeleteAccount()}
                              className="delete-account-button"
                            >
                              Permanently Delete Account
                            </button>
                          </div>
                          <div className="deleteAccount_info">
                            <p>
                              ⚠️ This action is irreversible. You'll have 30
                              days to cancel.
                            </p>
                          </div>
                          <div className="deleteAccount_help">
                            <Link to={"/support-chat"}>
                              <p>Need Help? Contact Support</p>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Replace the old modal with the new flow */}
              {showDeleteFlow && (
                <DeleteAccountFlow onClose={() => setShowDeleteFlow(false)} />
              )}
            </div>
          </div>
        </div>
      </div>
    </ProfileProvider>
  );
}
